import type { BaseFieldObject } from '@noths/polaris-client-google-analytics';

type ReturnedProduct = {
  product: {
    id: string;
  };
};

/**
 * @schema https://github.com/notonthehighstreet/analytics-schema-definitions/blob/main/objects/impression-list-view.json
 */
export type ProductImpressionsTrackingEvent = {
  attribution_token?: string;
  ecommerce?: {
    impressions: BaseFieldObject[];
  };
  event: 'product_impressions';
  event_action: 'Product Impressions' | 'Load More Impressions' | 'Load Previous Impressions';
  event_category: 'Product listings';
  event_label: string | null;
  offset?: number;
  returned_products?: ReturnedProduct[];
};

interface GetProductImpressionsTrackingEventArgs {
  attributionToken?: string;
  crsFilter?: string;
  eventAction: 'Product Impressions' | 'Load More Impressions' | 'Load Previous Impressions';
  eventCategory: 'Product listings';
  eventLabel: string | null;
  impressions?: BaseFieldObject[];
  offset?: number;
  returnedProducts?: ReturnedProduct[];
}

export const getProductImpressionsTrackingEvent = ({
  attributionToken,
  crsFilter,
  eventAction,
  eventCategory,
  eventLabel,
  impressions,
  offset,
  returnedProducts,
}: GetProductImpressionsTrackingEventArgs): ProductImpressionsTrackingEvent => {
  return {
    event: 'product_impressions',
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel,
    ...(attributionToken && { attribution_token: attributionToken }),
    ...(crsFilter && { crs_filter: crsFilter }),
    ...(impressions && { ecommerce: { impressions } }),
    ...(offset !== undefined && { offset }),
    ...(returnedProducts && { returned_products: returnedProducts }),
  };
};
